// src/layouts/PublicPageLayout.jsx
import { styled } from '@material-ui/core/styles';
import { Link as RouterLink } from 'react-router-dom';
import { Card, Stack, Container, Typography } from '@material-ui/core';
import Page from '../components/Page';
import { MHidden } from '../components/@material-extend';
import BotaoVoltarLayout from './BotaoVoltarLayout';

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 680,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

export default function PublicPageLayout({ title, FormComponent }) {
  return (
    <RootStyle title={title}>
      <BotaoVoltarLayout />

      <div className="fundotelalogin">
        <Container maxWidth="sm">
          <div className="logo-fencom">
            <img src="/static/logo.png" alt={title} />
          </div>

          <ContentStyle>
            <Stack sx={{ mb: 5 }}>
              <Typography variant="h4" gutterBottom>
                {title}
              </Typography>
              <Typography sx={{ color: 'text.secondary' }} />
            </Stack>

            {/* Aqui o form específico */}
            {FormComponent}

            <MHidden width="smUp">
              <Typography
                variant="body2"
                align="center"
                sx={{ mt: 3 }}
              ></Typography>
            </MHidden>
          </ContentStyle>
        </Container>
      </div>

      <div className="arealaterallogin">
        <MHidden width="mdDown">
          <br />
          <br />
          <h1> Produtos Fencom </h1>
          <RouterLink
            to={{ pathname: 'https://fencom.coop.br/sasc/' }}
            target="_blank"
          >
            SASC
          </RouterLink>

          <br />
          <br />

          <RouterLink
            to={{ pathname: 'http://inss.fencom.com.br:8085/#/' }}
            target="_blank"
          >
            INSS Cooperado
          </RouterLink>

          <br />
          <br />

          <RouterLink
            to={{ pathname: 'https://fencom.coop.br/sasc-connect/' }}
            target="_blank"
          >
            SASC Connect
          </RouterLink>

          <br />
          <br />

          <RouterLink
            to={{ pathname: 'https://sasccm.coop.br/' }}
            target="_blank"
          >
            SASC CM+
          </RouterLink>

          <br />
          <br />

          <h1> Suporte Fencom </h1>
          <RouterLink
            to={{ pathname: 'https://fencom.desk.ms/?LoginTicket' }}
            target="_blank"
          >
            DesKManager
          </RouterLink>

          <br />
          <br />

          <h1> Baixe nossos aplicativos : </h1>
          <div className="icones-app">
            <a href="">
              <img src="/static/icone-google.png" alt="login" />
            </a>
          </div>

          <div className="icones-app">
            <a href="">
              <img src="/static/icone-apple.png" alt="login" />
            </a>
          </div>
        </MHidden>
      </div>
    </RootStyle>
  );
}
